import { TournamentType } from './Tournament';

/** Hard safety cap applied to every tournament regardless of subscription plan. */
export const ABSOLUTE_MAX_PARTICIPANTS = 512;

export interface PlanLimits {
  maxActiveTournaments: number;
  maxParticipantsPerTournament: number;
  maxActiveLeagues: number;
  maxTournamentsPerLeague: number;
  maxPrivateTournaments: number;
  maxActiveTeams: number;
  allowedTournamentTypes: TournamentType[];
  canExportPdf: boolean;
  showWatermark: boolean;
  showAds: boolean;
}

export const FREE_LIMITS: PlanLimits = {
  maxActiveTournaments: 3,
  maxParticipantsPerTournament: 16,
  maxActiveLeagues: 1,
  maxTournamentsPerLeague: 3,
  maxPrivateTournaments: 1,
  maxActiveTeams: 1,
  allowedTournamentTypes: ['single_elimination', 'round_robin'],
  canExportPdf: false,
  showWatermark: true,
  showAds: true,
};

export const PRO_LIMITS: PlanLimits = {
  maxActiveTournaments: Infinity,
  maxParticipantsPerTournament: ABSOLUTE_MAX_PARTICIPANTS,
  maxActiveLeagues: Infinity,
  maxTournamentsPerLeague: Infinity,
  maxPrivateTournaments: Infinity,
  maxActiveTeams: Infinity,
  allowedTournamentTypes: ['single_elimination', 'double_elimination', 'round_robin', 'swiss', 'triple_elimination', 'king_of_the_hill'],
  canExportPdf: true,
  showWatermark: false,
  showAds: false,
};
